// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://matly-backend.onrender.com/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      localStorage.getItem("refresh")
    ) {
      originalRequest._retry = true;

      try {
        const res = await axios.post("https://matly-backend.onrender.com/api/token/refresh/", {
          refresh: localStorage.getItem("refresh"),
        });

        localStorage.setItem("access", res.data.access);
        api.defaults.headers["Authorization"] = "Bearer " + res.data.access;
        originalRequest.headers["Authorization"] = "Bearer " + res.data.access;

        return api(originalRequest);
      } catch (err) {
        console.error("Token refresh failed", err);
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        window.location.href = "/login"; // eller navigate hvis du bruger react-router
      }
    }

    return Promise.reject(error);
  }
);

export default api;